/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

import SpecificationResult from './specification';
import ComponentsResult from './component-selection';
import ToleranceResult from './tolerance';
import NextStepsResult from './next-steps';
import { filters } from '../../models/filter/filter';

export default class Results extends EmberObject {
  inputs = null;
  opAmpSource = null;
  @computed('inputs.{filterType,specifications}') get filter() {
    // const selectedResponseType = this.inputs.specifications.selectedResponseType;
    // const selectedFilterType = this.inputs.filterType;
    // const result = Filter.create({ selectedFilterType: selectedFilterType, selectedResponseType: selectedResponseType });
    // const result = filters[this.inputs.filterType];
    return filters[this.inputs.filterType];
  }

  @computed('filter', 'inputs.{filterType,specifications}') get specifications() {
    const specificationsInput = this.inputs.specifications;
    // const filter = this.filter;

    return SpecificationResult.create({
      filter: filters[this.inputs.filterType],
      specificationsInput: specificationsInput,
    });
  }

  @computed('filter', 'inputs.{components,filterType,noise}', 'opAmpSource', 'specifications') get components() {
    // const filter = this.filter;
    // const specifications = this.specifications;
    // const componentsInput = this.inputs.components;
    // const noiseInput = this.inputs.noise;
    // const opAmpSource = this.opAmpSource;
    return ComponentsResult.create({
      filter: filters[this.inputs.filterType],
      specifications: this.specifications,
      componentsInput: this.inputs.components,
      noiseInput: this.inputs.noise,
      opAmpSource: this.opAmpSource,
    });
  }

  @computed('components', 'inputs.{components,specifications,tolerances}') get tolerances() {
    // const components = this.components;
    // const toleranceInput = this.inputs.tolerances;
    // const specificationsInput = this.inputs.specifications;
    // const componentsInput = this.inputs.components;
    // const result = ToleranceResult.create({
    //   components: this.components,
    //   componentsInput: this.inputs.components,
    //   toleranceInput: this.inputs.tolerances,
    //   specificationsInput: this.inputs.specifications,
    // });
    return ToleranceResult.create({
      components: this.components,
      componentsInput: this.inputs.components,
      toleranceInput: this.inputs.tolerances,
      specificationsInput: this.inputs.specifications,
    });
  }

  @computed('filter', 'inputs.{components,filterType,specifications,tolerances}', 'opAmpSource', 'tolerances')
  get nextSteps() {
    // const filter = this.filter;
    // const tolerances = this.tolerances;
    // const specificationsInput = this.inputs.specifications;
    // const componentsInput = this.inputs.components;
    // const toleranceInput = this.inputs.tolerances;
    // const opAmpSource = this.opAmpSource;
    // const result = NextStepsResult.create({
    //   filter: filters[this.inputs.filterType],
    //   tolerances: this.tolerances,
    //   specificationsInput: this.inputs.specifications,
    //   componentsInput: this.inputs.components,
    //   toleranceInput: this.inputs.tolerances,
    //   opAmpSource:  this.opAmpSource,
    // });
    return NextStepsResult.create({
      filter: filters[this.inputs.filterType],
      tolerances: this.tolerances,
      specificationsInput: this.inputs.specifications,
      componentsInput: this.inputs.components,
      toleranceInput: this.inputs.tolerances,
      opAmpSource: this.opAmpSource,
    });
  }
}
